import {
    BcmEmployee,
    BcmEmployeeDto,
    EmployeePosition,
} from '@shared/models/bcm-employee';

export type DepartmentEmployeeAssignmentType = 'primary' | 'additional';

export interface DepartmentEmployeeSummaryDto extends BcmEmployeeDto {
    assignmentType?: DepartmentEmployeeAssignmentType;
}

export class DepartmentEmployeeSummary extends BcmEmployee {
    assignmentType: DepartmentEmployeeAssignmentType;

    constructor(dto: DepartmentEmployeeSummaryDto = {} as DepartmentEmployeeSummaryDto) {
        super(dto);
        this.assignmentType = dto.assignmentType ?? 'primary';
    }

    get isPrimaryAssignment(): boolean {
        return this.assignmentType === 'primary';
    }

    get positionTranslationKey(): string | null {
        if (!this.position) {
            return null;
        }

        return `bcmEmployees.position.${this.position}`;
    }

    get assignmentTranslationKey(): string {
        return this.isPrimaryAssignment
            ? 'bcmDepartments.core.employees.assignmentPrimary'
            : 'bcmDepartments.core.employees.assignmentAdditional';
    }

    get currentPrimaryDepartmentName(): string {
        return this.primaryDepartment?.name ?? '';
    }
}

export function getEmployeePositionLabelKey(position: EmployeePosition | null): string | null {
    if (!position) {
        return null;
    }

    return `bcmEmployees.position.${position}`;
}
